import { MAX_INTEGER } from "@/constants/common";
import { BILLING_CYCLE, INVOICE_DISPLAY_FORMAT, TBillingCycle, TInvoiceDisplayFormat } from "@/types/enum";
import { validator } from "@/utils/validator";

export const masterDataDefaultProductSchema = validator.object().shape({
  productName: validator.string().trim().emptyToNull().label("商品名").required().max(100),
  // 単位は暫定的に自由入力（DB のカラム長に合わせて 20 文字まで）
  unit: validator.string().trim().emptyToNull().label("単位").required().max(20),
  taxRateId: validator.number().isSelection().emptyToNull().max(MAX_INTEGER).label("税率").required(),
  isContractLinked: validator.boolean().label("契約紐付け").required(),
  // DB 側で null 許容のため、画面でも未選択を許可する
  invoiceDisplayFormat: validator
    .string<TInvoiceDisplayFormat>()
    .isSelection()
    .emptyToNull()
    .nullable()
    .oneOf([...Object.values(INVOICE_DISPLAY_FORMAT), null])
    .label("請求書表示形式"),
  billingCycle: validator.string<TBillingCycle>().isSelection().emptyToNull().oneOf(Object.values(BILLING_CYCLE)).label("請求サイクル").required(),
  isTierDiscountTarget: validator.boolean().label("ティア・初回割引の対象").required(),
  accountingItemMapping: validator.string().trim().emptyToNull().label("会計の品目マッピング").max(100).nullable(),
});
